'use strict';

angular.module('shiftTraderApp')
  .service('TagCloud', ['$http', 'ServerUrls', 'Session', '$q', function ($http, ServerUrls, Session, $q) {

    var getTagCloud = function() {
      var deferred = $q.defer();
      $http.get(ServerUrls.current.railsApi + 'tag_cloud')
        .then(function(response) {
          deferred.resolve(response.data);
        }, function(response) {
          deferred.reject(response);
        });

      return deferred.promise;
    };

    return {
      getAll: getTagCloud
    };

  }]);
